import ReactMarkdown from 'react-markdown';
import { Checkbox, Typography } from '@arionbanki/arionui';
import { interestsList } from './interestsConsts';
import { ProgressBar, Footer } from 'components';
import { useInterests } from './useInterests';

export function Interests() {
	const { t, ...props } = useInterests();
	return (
		<ProgressBar page="interests">
			<Typography TagName="h3" className="mb-5">
				{t('sidebar_interests', 'interests')}
			</Typography>
			<ReactMarkdown className="arionui mb-5">{t('description_text', 'interests')}</ReactMarkdown>
			<Typography TagName="h6" className="mb-4">
				{t('sidebar_my_interests', 'interests')}
			</Typography>
			{interestsList.map(key => (
				<p key={key}>
					<Checkbox
						checked={props.selected[key]}
						id={key}
						label={t(key, 'interests')}
						onChange={isChecked => props.toggleChecked(key, isChecked)}
					/>
				</p>
			))}
			<p className="mt-5">
				<Checkbox
					checked={props.selected.allowStoring}
					id="allowStoring"
					label={t('allowStoring', 'interests')}
					onChange={is => props.toggleChecked('allowStoring', !!is)}
				/>
			</p>
			<Footer
				handleNext={props.handleNext}
				handlePrev={props.goBack}
				isDisabled={props.someSelected ? !props.selected.allowStoring : false}
				next={t('continue')}
				prev={t('back')}
			/>
		</ProgressBar>
	);
}
